import { ReactElement } from "react";
import { Box, Text } from "@chakra-ui/react";

import resultGradationGrayImageUrl from "/src/assets/images/mci/result_gradation_gray.png";
import resultFaceiconErrorImageUrl from "/src/assets/images/mci/result_faceicon_error.png";

export function ResultError(): ReactElement {
  return (
    <Box
      sx={{
        ".result_title": {
          marginTop: "0.5em",
          fontSize: "30px",
        },
        ".result_text_summary": {
          marginTop: "0.5em",
          marginBottom: "0.5em",
          fontSize: "40px",
        },

        ".result_faceicon": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "1.5em",
        },
        ".result_faceicon img": {
          width: "60%",
        },
        "@media (max-width: 599px)": {
          ".result_text_summary": {
            marginTop: "0.4em",
            marginBottom: "0.5em",
            fontSize: "30px",
          },
          ".result_faceicon": {
            marginBottom: "1.5em",
          },
          ".result_faceicon img": {
            width: "50%",
          },
        },
      }}
    >
      <Box className="result_text_summary">
        <Text textAlign="center">計算エラー</Text>
      </Box>
      <Box className="result_gradation">
        <Box position="relative">
          <img
            className="record_sample_img_01"
            src={resultGradationGrayImageUrl}
            alt=""
          />
        </Box>
      </Box>
      <Box className="result_faceicon">
        <img
          className="record_sample_img_01"
          src={resultFaceiconErrorImageUrl}
          alt=""
        />
      </Box>
    </Box>
  );
}
